export default Object.freeze({
  loginDetails: {},
  excludedTypes: {},
});
